export function convertENotationToDecimal(num: number | null, startFromPrecision: number) {
    if (num === null) return null;

    const numStr = num.toString();
    const isExponential = numStr.match(/[eE]/);
    if (!isExponential) {
        return num;
    }
    let precision = startFromPrecision;
    let result = `${parseFloat(num.toFixed(precision))}`;
    while (result.includes('e')) {
        precision--;
        if (precision < 0) {
            throw new Error('Unable to convert to decimal');
        }
        result = `${parseFloat(num.toFixed(precision))}`;
    }
    return parseFloat(result);
}
